import { useEffect } from 'react';

export const useBodyDragOver = (onDragOver: (event: DragEvent) => void) => {
  useEffect(() => {
    const handleDragOver = (event: DragEvent) => {
      event.preventDefault();
      onDragOver(event);
    };

    document.body.addEventListener('dragover', handleDragOver);

    return () => {
      document.body.removeEventListener('dragover', handleDragOver);
    };
  }, [onDragOver]);
};
